module.exports = __webpack_public_path__ + "static/media/bounds_cylinder1.2bbdc616.jpg";